"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BwmConfig = void 0;
var _bwmThemeContext = require("./bwmThemeContext");
var _bwmAboutOwner = require("./quoteTools/bwmAboutOwner");
var _bwmAboutPet = require("./quoteTools/bwmAboutPet");
var _bwmCoverDisplayOptions = require("./quoteTools/bwmCoverDisplayOptions");
var _bwmQuoteToolContext = require("./quoteTools/bwmQuoteToolContext");
var _bwmSuccess = require("./quoteTools/bwmSuccess");
var _bwmSummary = require("./quoteTools/bwmSummary");
var _defaultAuthorisedPersonDisplaySettings = require("../../defaults/quoteTools/defaultAuthorisedPersonDisplaySettings");
var _defaultCustomRouteDefinitions = require("../../defaults/quoteTools/defaultCustomRouteDefinitions");
var _defaultRegularVetDisplaySettings = require("../../defaults/quoteTools/defaultRegularVetDisplaySettings");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _icons = require("./productTable/icons");
var _bwmStepDefinitions = require("./quoteTools/bwmStepDefinitions");
var _defaultPayment = require("../../defaults/quoteTools/defaultPayment");
var BwmConfig = exports.BwmConfig = {
  theme: _bwmThemeContext.BwmThemeContext,
  quoteTools: {
    transmitSecurity: {
      enabled: true,
      sit: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      uat: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      preprod: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      prod: {
        clientId: 'kDitGyYonNFmQs9ibNASz'
      }
    },
    themeOverrides: _bwmQuoteToolContext.BwmQuoteToolContext,
    steps: {
      StepDefinitions: _bwmStepDefinitions.BwmStepDefinitions,
      basicOwnerDetails: _bwmAboutOwner.BwmAboutOwner,
      fullOwnerDetails: _bwmAboutOwner.BwmAboutOwner,
      aboutPet: _bwmAboutPet.BwmAboutPet,
      coverDisplayOptions: _bwmCoverDisplayOptions.BwmCoverDisplayOptions,
      summary: _bwmSummary.BwmSummary,
      success: _bwmSuccess.bwmSuccess,
      payment: _defaultPayment.defaultPayment,
      bannerStyle: 'bullets',
      showCompletedStepBannerOnPage: 'step6'
    },
    widgets: {
      authorisedPersonDisplaySettings: _defaultAuthorisedPersonDisplaySettings.defaultAuthorisedPersonDisplaySettings,
      regularVetDisplaySettings: _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings
    },
    customRouteDefinitions: _defaultCustomRouteDefinitions.DefaultCustomRouteDefinitions,
    staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
    productTable: {
      optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
      staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
      icons: _icons.icons
    },
    middlewareApiKeys: {
      "public": {
        sit: {
          applicationId: 'C6F0D487-EFC1-4E35-95E0-6CF417ADB4BF',
          apiKey: '6KE0CC34B5849F49109',
          expiry: 3600
        },
        uat: {
          applicationId: 'C6F0D487-EFC1-4E35-95E0-6CF417ADB4BF',
          apiKey: '6KE0CC34B5849F49109',
          expiry: 3600
        },
        preprod: {
          applicationId: 'C0A05B7E-6520-4C5A-A5B2-EC4EAC8522E0',
          apiKey: '8053B05F371F460D96',
          expiry: 3600
        },
        prod: {
          applicationId: 'E0975670-1574-4BC7-9F99-02645EFDFB26',
          apiKey: '1A03B54DA5FC4D9697',
          expiry: 3600
        }
      }
    },
    recaptchaSiteKey: '6LepTOskAAAAAKFnSbx6guHunZYAOoPL2NAIGbbm',
    recaptchaSecretKey: '6LepTOskAAAAAKccTgJ-0e6SDR_OE9iu5gnmXmr1',
    recaptchaSiteKeyProd: '6LcRT-skAAAAALwt8hHT2lWfPIpJBxFZAzXlKiw3',
    recaptchaSecretKeyProd: '6LcRT-skAAAAAKYfgd4mN6guTSwF-_XXFss9_VWu'
  }
};